module.exports = __webpack_public_path__ + "static/menikmati-macet-jakarta-598d3ea160c07ab389baecaf94ec5ce8.png";